type CircularProgressProps = {
  value: number; 
  size?: number;
  strokeWidth?: number;
};

export function CircularProgress({
  value,
  size = 116,
  strokeWidth = 8,
}: CircularProgressProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (value / 100) * circumference;

  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className="-rotate-90">
        {/* Background circle */}
        <circle
          stroke="#f5f5f5"
          fill="transparent"
          strokeWidth={strokeWidth}
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />

        {/* Progress circle */}
        <circle
          stroke="url(#gradient)"
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />

        {/* Gradient */}
        <defs>
        <linearGradient id="gradient" x1="100%" y1="0%" x2="0%" y2="0%">
      <stop offset="0%" stopColor="#ffe8e0ff" />
      <stop offset="30%" stopColor="#ff8a65" />
      <stop offset="100%" stopColor="#ff3d00" />
      </linearGradient>
        </defs>
      </svg>

      {/* Center text */}
      <span className="absolute text-[#0A0A0A] text-3xl font-semibold">
        {value}%
      </span>
    </div>
  );
}